module.exports = __webpack_public_path__ + "static/media/stop-18.7dcd7fad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-18.svg
// module id = 1385
// module chunks = 0